import { render, staticRenderFns } from "./BookingSteps.vue?vue&type=template&id=38861060"
import script from "./BookingSteps.vue?vue&type=script&lang=js"
export * from "./BookingSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports